/**
 * Density context (TMMAPP-0004). `density` is the user's persisted layout-density preference
 * (comfortable / compact); it varies spacing only — never a color (the contrast audit is
 * density-blind by construction, see `buildAppTheme`).
 */
import { createContext, useContext } from 'react';

export type Density = 'comfortable' | 'compact';

export interface DensityContextValue {
  density: Density;
  setDensity: (density: Density) => void;
}

export const DensityContext = createContext<DensityContextValue>({
  density: 'comfortable',
  setDensity: () => {},
});

export function useDensity(): DensityContextValue {
  return useContext(DensityContext);
}
